import {
  Home,
  CalendarClock,
  TicketCheck,
  User,
} from "lucide-react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { NavItem } from "./NavItem";
import { useTab } from "../../../store/useTab";
import { useStore } from "../../../store";
import { hasPermission } from "../../../utils/helpers";

function tabFromPathname(pathname: string): string {
  if (pathname.startsWith("/eventos")) return "Eventos";
  if (pathname.startsWith("/ingressos")) return "Ingressos";
  if (pathname.startsWith("/perfil")) return "Perfil";
  if (pathname.startsWith("/inicio")) return "Início";
  return "";
}

export function Navigation() {
  const user = useStore((store) => store.user);
  const currentTab = useTab((store) => store.tab);
  const setCurrentTab = useTab((store) => store.setTab);
  const { pathname } = useLocation();

  useEffect(() => {
    const next = tabFromPathname(pathname);
    if (next && next !== currentTab) {
      setCurrentTab(next);
    }
  }, [pathname, currentTab, setCurrentTab]);

  const selected = tabFromPathname(pathname) || currentTab;

  return (
    <nav className="flex flex-col gap-0.5">
      <NavItem
        icon={Home}
        title="Início"
        link="/inicio"
        isSelected={selected === "Início"}
        setCurrentTab={setCurrentTab}
      />

      <NavItem
        icon={CalendarClock}
        title="Eventos"
        link="/eventos"
        isSelected={selected === "Eventos"}
        setCurrentTab={setCurrentTab}
      />

      {hasPermission(user.user_type) && (
        <NavItem
          icon={TicketCheck}
          title="Ingressos"
          link="/ingressos"
          isSelected={selected === "Ingressos"}
          setCurrentTab={setCurrentTab}
        />
      )}

      <NavItem
        icon={User}
        title="Perfil"
        link="/perfil"
        isSelected={selected === "Perfil"}
        setCurrentTab={setCurrentTab}
      />
    </nav>
  );
}
